import ComposerActionCreators from '../../action-creators/ComposerActionCreators'

export const useSetDraftsScheduledAt = (): {
  setDraftsScheduledAt: (scheduledAt: number | null) => void
} => {
  const setDraftsScheduledAt = (scheduledAt: number | null): void => {
    ComposerActionCreators.updateDraftsScheduledAt(
      scheduledAt,
      // alwasy set pinned false
      false,
    )
  }

  return {
    setDraftsScheduledAt,
  }
}
